import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteNoteRes } from "./helper";

const deleteNote = async (id: number) =>
  axios.delete(Routes.DELETE_NOTE + "/" + id);

export const useDeleteNote = () =>
  useMutation({
    mutationKey: [Keys.DELETE_NOTE_MUT],
    mutationFn: deleteNote,
    onSuccess: onDeleteNoteRes,
  });
